module.exports = __webpack_public_path__ + "img/bana_2kl.b4303c67.jpg";